<template>
  <Content />
</template>
  <script route="/business/account/management">
  import Content from '@/views/fin/account_management/Content.jsx'
  export default {
    components: {
      Content
    }   
  }
  </script>